import { Helmet } from '@dr.pogodin/react-helmet';
import { format } from 'date-fns';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';
import Functions from '../functions';
import './assets/xwords.css';
import XwordsBreadcrumbs from './lib/XwordsBreadcrumbs';
import XwordsCategoryFieldset from './lib/XwordsCategoryFieldset';
import XwordsInitialFieldset from './lib/XwordsInitialFieldset';
import XwordsUtils from './lib/XwordsUtils';

interface Props {
    lang: MultiLang;
    entryId: number;
}

const XwordsEntry = (props: Props) => {
    const { lang, entryId } = props;
    const name = XwordsUtils.getName();
    const entry = XwordsUtils.getEntry(entryId);
    if (null == entry) {
        return <PageNotFound lang={lang} />;
    }

    const mtitle = Functions.mlang(name, lang);
    const title = Functions.mlang(entry.term, lang);
    const date = format(new Date(entry.timestamp * 1000), lang === 'en' ? 'MMMM do, yyyy' : 'yyyy年M月d日');

    return (
        <div className="xwords">
            <Helmet>
                <title>
                    {title} - {mtitle} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h3>{title}</h3>
            <NoticeSiteHasBeenArchived lang={lang} />
            <XwordsBreadcrumbs lang={lang} catId={entry.cat_id} initial={entry.initial} entryId={entry.id} />
            <div className="row">
                <XwordsCategoryFieldset lang={lang} />
            </div>
            <div className="row">
                <XwordsInitialFieldset lang={lang} catId={entry.cat_id} />
            </div>
            <div className="entry">
                <h4 className="title">{Functions.mlang(title, lang)}</h4>
                <div className="description">
                    <div className="yomi">{Functions.mlang(`[en]Yomi[/en][ja]読み[/ja] : ${entry.yomi}`, lang)}</div>
                    <div className="definition">{Functions.mlang(entry.definition, lang)}</div>
                    <div className="note">
                        <span className="date">
                            {Functions.mlang('[en]Date[/en][ja]投稿日[/ja]', lang)} : {date}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default XwordsEntry;
